<template>
<v-dialog width="500" v-model="dialog">
  <v-btn fab dark :small="small" color="deep-purple" slot="activator">
    <v-icon>description</v-icon>
  </v-btn>
  <v-card>
    <v-card-title class="headline" primary-title>
      {{ $t('schema.builder.inputs.description.label') }}
    </v-card-title>
    <v-divider />
    <v-textarea box :label="`${$t('schema.builder.inputs.description.input', { 'field-name': fieldName })}`" :value="description" @input="$emit('update', $event)" auto-grow></v-textarea>
    <div>
      <v-text-field color="primary" :label="`${$t('schema.builder.inputs.description.photo')}`" :value="files.map(el => el.local).join(', ')" readonly @click="onPickFile" :loading="loading"></v-text-field>
      <input type="file" style="display: none" ref="fileInput" accept="*/*" @change="onFilePicked">
    </div>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn round color="primary" @click="dialog = false">
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>
<script>
import http from '@/plugins/http'
import FileValidator from '@/plugins/FileValidator'
export default {
  props: ["fieldName", "description", "small", "id"],
  data() {
    return {
      files: [],
      field: {},
      loading: false,
      dialog: false,
      imgValidator: new FileValidator()
    }
  },
  methods: {
    onPickFile() {
      if (!this.loading)
        this.$refs.fileInput.click()
    },
    sendImage(base64Image, name) {
      this.loading = true;

      http.post('image/description', {
        name: name,
        data: base64Image
      })
        .then(data => {
          this.files.push({
            name: data.data,
            local: name
          }) //Images are seting in options
          this.$emit("updateImages", {
            id: this.id,
            options: {
              images: this.files.map(el => el.name)
            }
          })
        })
        .catch(() => {
          this.showErrorMessage(this.$t('schema.builder.inputs.description.problem_with_send'))
        })
        .finally(() => this.loading = false)
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.model = fr.result.split(';base64,')[1];

          if (!this.validate(files[0])) {
            return;
          }
          this.sendImage(this.model, files[0].name)
        })
      } else {
        this.showErrorMessage(this.$t('schema.builder.inputs.description.choose_file'))
      }
    },
    validate(file) {
      if (!this.imgValidator.validate(file)) return false

      if (this.files.find(el => el.local == file.name) != undefined) {
        this.showErrorMessage(this.$t('schema.builder.inputs.description.before_aded'))
        return false
      }

      return true
    },
    showErrorMessage(msg) {
      this.$store.commit("setSnack", {
        message: msg,
      })
    }
  }
}
</script>
<style>
</style>
